// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { css } from "styled-components";

/**
 * To Check if string empty by remove empty space and check by string
 * @param value
 */
export const isEmptyString = (value?: string) => (value ? value.trim().length <= 0 : false);

/**
 * To make a word into a form that expresses more than one
 * @param count
 * @param noun
 * @param otherProps
 *
 */
export const pluralize = (
    count: number,
    noun: string,
    otherProps?: { suffix?: string; showNumber?: boolean },
): string =>
    `${otherProps?.showNumber ? `${count} ` : ""}${noun}${count !== 1 ? otherProps?.suffix || "s" : ""}`.trim();

export const ellipsis = (maxNoLines: number) => {
    return css`
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${maxNoLines};
    `;
};
